// extracted by mini-css-extract-plugin
export default {"fullscreen":"styles-module--fullscreen--da3dd","image":"styles-module--image--9a550","container":"styles-module--container--56196"};